import React from 'react';
import { CountdownBar } from '../components/CountdownBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Reframe } from '../components/Reframe';
import { ProductIntro } from '../components/ProductIntro';
import { Benefits } from '../components/Benefits';
import { Bonuses } from '../components/Bonuses';
import { Inclusions } from '../components/Inclusions';
import { OfferCard } from '../components/OfferCard';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { HelpVideo } from '../components/HelpVideo';
import { Faq } from '../components/Faq';
import { PurchaseToast } from '../components/PurchaseToast';
import { Sparkle } from '../components/Sparkle';
type LandingProps = {
  showPurchaseToast: boolean;
};
export function Landing({
  showPurchaseToast
}: LandingProps) {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-173" data-mp="m8n0fxz04g3c">
      <CountdownBar data-id="element-174" data-mp="2a0lycb4uw9w" />
      <Hero data-id="element-175" data-mp="2aad437wz9h6" />
      <main data-id="element-176" data-mp="2b39ca98ygl2">
        <PainPoints data-id="element-177" data-mp="2blgi1xg6f7r" />
        <Reframe data-id="element-178" data-mp="27xk8v0mbepc" />
        <ProductIntro data-id="element-179" data-mp="3tgbflndtcur7" />
        <Benefits data-id="element-180" data-mp="3tftk4syz6kkc" />
        <Bonuses data-id="element-181" data-mp="3tfa7nrs3godp" />
        <Inclusions data-id="element-182" data-mp="3tes2g5ngeztn" />
        <OfferCard id="oferta" data-id="element-183" data-mp="3tio8gvl40pj1" />
        <Testimonials data-id="element-184" data-mp="3pe83cwjblm4v" />
        <Guarantee data-id="element-185" data-mp="3pfj6cu4xypux" />
        <OfferCard data-id="element-186" data-mp="3pf00ibskfrx9" />
        <HelpVideo data-id="element-187" data-mp="3pgkt3vvbl0sh" />
        <Faq data-id="element-188" data-mp="3kfwt4kp459m4" />
      </main>
      <footer className="border-t-2 border-ink bg-ink py-8 text-center text-sm text-kraft-light" data-id="element-189" data-mp="3kgoobuest5bv">
        <p className="flex items-center justify-center gap-2 font-display font-bold text-cream" data-id="element-190" data-mp="kzgof56doysy">
          <Sparkle className="h-3 w-3" data-id="element-191" data-mp="gzzi69j4nxmq" /> Diario de Prioridad <Sparkle className="h-3 w-3" data-id="element-192" data-mp="h1amcaghj7ed" />
        </p>
        <p className="mt-2" data-id="element-193" data-mp="c76elozeavc8">© {new Date().getFullYear()} · Producto digital en PDF</p>
      </footer>
      {showPurchaseToast && <PurchaseToast data-id="element-194" data-mp="78v2t8pjiard" />}
    </div>;
}